import { axiosBase, errorHandler } from "./axios";

const getCommentsList = (data: { albumId: string; pageId: string; nodeId?: number }) => {
  return axiosBase.post("/api/v1/comments/list", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const addComment = (data: { albumId: string; pageId: string; nodeId: string; message: string; eventId?: string }) => {
  return axiosBase.post("/api/v1/comments/add", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const editComment = (commentId: string, data: { message: string; eventId?: string }) => {
  return axiosBase.put(`/api/v1/comments/edit/${commentId}`, data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

export const commentService = {
  getCommentsList,
  addComment,
  editComment,
};